<template>
  <v-container
    fluid
    style="height: 100%; margin:0px; padding:0px; min-height: inherit"
    class="d-flex flex-row"
  >
    <volunteer-profile-left-section class="hidden-sm-and-down" />
    <volunteer-profile-feed-section />
  </v-container>
</template>
<script>
import VolunteerProfileFeedSection from "./VolunteerProfileFeedSection.vue";
import VolunteerProfileLeftSection from "./VolunteerProfileLeftSection.vue";
export default {
  components: { VolunteerProfileFeedSection, VolunteerProfileLeftSection }
};
</script>
